import { Controller } from "@hotwired/stimulus"

// Opens a single <dialog> as an editor for creating / updating / deleting a Holiday.
// Clicked day cells expose their date (and optionally holiday id / name) via data-*,
// which this controller reads to configure the form before showing the dialog.
export default class extends Controller {
  static targets = [
    "dialog",
    "title",
    "form",
    "deleteForm",
    "dateInput",
    "dateLabel",
    "nameInput",
    "submitButton",
    "deleteButton",
  ]
  static values = {
    createUrl: String,
    updateUrlTemplate: String, // e.g. "/holidays/:id"
    deleteUrlTemplate: String,
  }

  open(event) {
    const cell = event.currentTarget
    const date = cell.dataset.date
    const holidayId = cell.dataset.holidayId
    const name = cell.dataset.name || ""

    this.dateInputTarget.value = date
    this.dateLabelTarget.textContent = date
    this.nameInputTarget.value = name

    if (holidayId) {
      this.titleTarget.textContent = "休日を編集"
      this.formTarget.action = this.updateUrlTemplateValue.replace(":id", holidayId)
      this.setMethod(this.formTarget, "patch")
      this.deleteFormTarget.action = this.deleteUrlTemplateValue.replace(":id", holidayId)
      this.deleteButtonTarget.classList.remove("hidden")
      this.submitButtonTarget.textContent = "更新"
    } else {
      this.titleTarget.textContent = "休日を追加"
      this.formTarget.action = this.createUrlValue
      this.setMethod(this.formTarget, "post")
      this.deleteButtonTarget.classList.add("hidden")
      this.submitButtonTarget.textContent = "追加"
    }

    this.dialogTarget.showModal()
    this.nameInputTarget.focus()
  }

  close() {
    this.dialogTarget.close()
  }

  // Click on backdrop (outside the inner card) closes the dialog.
  backdropClick(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  setMethod(form, method) {
    let input = form.querySelector("input[name='_method']")
    if (method === "post") {
      if (input) input.remove()
      form.method = "post"
      return
    }
    if (!input) {
      input = document.createElement("input")
      input.type = "hidden"
      input.name = "_method"
      form.appendChild(input)
    }
    input.value = method
    form.method = "post"
  }
}
